import { BACKEND_BASE } from '../../constants'

function dataURItoBlob(dataURI: string): Blob {
  const byteString = atob(dataURI.split(',')[1])
  const mimeString = dataURI
    .split(',')[0]
    .split(':')[1]
    .split(';')[0]

  const ab = new ArrayBuffer(byteString.length)
  let ia = new Uint8Array(ab)

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }

  const blob = new Blob([ab], { type: mimeString })
  return blob
}

// Creates a new, scaled down canvas element for the thumbnail.
function setupThumbnailCanvas(actual: HTMLCanvasElement) {
  const canvas = document.createElement('canvas')
  const tw = 540
  const th = 300
  const aspect = tw / th

  canvas.width = tw // actual.width * 0.41
  canvas.height = th // actual.height * 0.41

  // Source position to read from
  let sx = 0
  let sy = 0

  // source sizes
  let sw = actual.width
  let sh = actual.height

  // Find largest possible area for thumbnail. If the image is very tall, we try to use all
  // horizontal space available and if the image is wide, we cut out the sides but consume
  // all space vertically.
  if (sw > sh) {
    // Wider
    sh = sw / aspect
    sy = sh / 2 - th / 2 - 30
  } else {
    // Taller
    sh = sw / aspect
    // - 30 is an arbitrary number here. The generated thumbnail just positions itself
    // better when we start from bit higher up
    sy = Math.max(0, actual.height / 2 - th / 2 - 30)
  }

  canvas
    .getContext('2d')!
    // .drawImage(actual, 0, 0, canvas.width, canvas.height)
    .drawImage(actual, sx, sy, sw, sh, 0, 0, tw, th)

  return canvas
}

export function getThumbnailDataUrl(elem: HTMLCanvasElement) {
  const thumbnailCanvas = setupThumbnailCanvas(elem)
  const dataUrl = thumbnailCanvas.toDataURL('image/png')
  return dataUrl
}

export function saveThumbnail(caseId: string, elem: HTMLCanvasElement) {
  return new Promise((resolve, reject) => {
    const dataUrl = getThumbnailDataUrl(elem)
    let fd = new FormData()
    const blob = dataURItoBlob(dataUrl)
    fd.append('thumbnail', blob)

    const xhr = new XMLHttpRequest()
    const token = window.localStorage.getItem('peikko-dbs-token')
    if (!token) {
      // TODO: show error
      return
    }

    xhr.open('POST', `${BACKEND_BASE}upload/${caseId}`, true)
    xhr.setRequestHeader('Authorization', `Bearer ${token}`)

    xhr.onload = function() {
      if (this.status === 200) {
        console.log('Thumbnail successfully stored')
        return resolve(true)
      }
      return resolve(false)
    }
    xhr.send(fd)
  })
}



// WEBPACK FOOTER //
// ./src/Components/ProjectToolbar/thumbnail.ts